module.exports = __webpack_public_path__ + "img/baisxiao.84b578a7.svg";